import { render, staticRenderFns } from "./specialOrderList.vue?vue&type=template&id=a98e740c&scoped=true"
import script from "./specialOrderList.vue?vue&type=script&lang=js"
export * from "./specialOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98e740c",
  null
  
)

export default component.exports